import { useTranslation } from "react-i18next";
import { FeatureSection, MultiDeviceSection } from "../components/features";

export function Features() {
  const { t } = useTranslation();

  return (
    <div className="py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 md:mb-20">
          <h1 className="text-4xl md:text-5xl font-bold text-warm-50 mb-4">
            {t("features.header.title")}
          </h1>
          <p className="text-warm-400 text-lg max-w-3xl mx-auto leading-relaxed">
            {t("features.header.subtitle")}
          </p>
        </div>

        {/* Feature Sections — alternating layout */}
        <div className="divide-y divide-dark-border">
          {/* 1. Works Everywhere — moved to top */}
          <MultiDeviceSection
            title={t("features.multiDevice.title")}
            description={t("features.multiDevice.description")}
            note={t("features.multiDevice.note")}
          />

          {/* 2. Flexible Workspace */}
          <FeatureSection
            title={t("features.workspace.title")}
            description={t("features.workspace.description")}
            imageSrc="/images/ade/ade-layout-switcher.png"
            imageAlt={t("features.workspace.layoutSwitcher")}
            imageCaption={t("features.workspace.layoutSwitcherCaption")}
            secondaryImageSrc="/images/ade/ade-panel-catalog.png"
            secondaryImageAlt={t("features.workspace.panelCatalog")}
            secondaryImageCaption={t("features.workspace.panelCatalogCaption")}
            bullets={t("features.workspace.bullets", { returnObjects: true }) as string[]}
          />

          {/* 3. AI Agents */}
          <FeatureSection
            title={t("features.agents.title")}
            description={t("features.agents.description")}
            imageSrc="/images/ade/ade-project-and-chat.png"
            imageAlt={t("features.agents.title")}
            imageCaption={t("features.agents.chatCaption")}
            secondaryImageSrc="/images/ade/ade-tasks-and-agents.png"
            secondaryImageAlt={t("features.agents.tasksAndAgents")}
            secondaryImageCaption={t("features.agents.tasksCaption")}
            bullets={t("features.agents.bullets", { returnObjects: true }) as string[]}
          />

          {/* 4. IDE Mode */}
          <FeatureSection
            title={t("features.ide.title")}
            description={t("features.ide.description")}
            imageSrc="/images/ade/ade-ide-mode.png"
            imageAlt={t("features.ide.title")}
            imageCaption={t("features.ide.caption")}
            reverse
          />

          {/* 5. Documents & Knowledge */}
          <FeatureSection
            title={t("features.documents.title")}
            description={t("features.documents.description")}
            imageSrc="/images/ade/ade-documents-editor.png"
            imageAlt={t("features.documents.title")}
            imageCaption={t("features.documents.editorCaption")}
            secondaryImageSrc="/images/ade/ade-documents.png"
            secondaryImageAlt={t("features.documents.title")}
            secondaryImageCaption={t("features.documents.listCaption")}
          />

          {/* 6. Planning & Project Management */}
          <FeatureSection
            title={t("features.planning.title")}
            description={t("features.planning.description")}
            imageSrc="/images/ade/ade-planning.png"
            imageAlt={t("features.planning.title")}
            imageCaption={t("features.planning.caption")}
            reverse
          />

          {/* 7. Tasks & Automation */}
          <FeatureSection
            title={t("features.tasks.title")}
            description={t("features.tasks.description")}
            imageSrc="/images/ade/ade-tasks-and-agents.png"
            imageAlt={t("features.tasks.title")}
            imageCaption={t("features.tasks.caption")}
            bullets={t("features.tasks.bullets", { returnObjects: true }) as string[]}
          />

          {/* 8. Media & Content */}
          <FeatureSection
            title={t("features.media.title")}
            description={t("features.media.description")}
            imageSrc="/images/ade/ade-media-content.png"
            imageAlt={t("features.media.title")}
            imageCaption={t("features.media.caption")}
            reverse
          />

          {/* 9. Version Control */}
          <FeatureSection
            title={t("features.git.title")}
            description={t("features.git.description")}
            imageSrc="/images/ade/ade-git-workflow.png"
            imageAlt={t("features.git.title")}
            imageCaption={t("features.git.caption")}
          />
        </div>
      </div>
    </div>
  );
}
